import { combineReducers } from 'redux';
import agentSummaryReducer from './agentSummary.reducers';

const reducer = combineReducers(Object.assign({
    agentSummary: agentSummaryReducer
}));

export default reducer;